export const publicLabsCatalog = {
  browseTitle: "Labs catalog",
  browseDescription: "Browse functional lab tests and panels.",
  browseSubtitle:
    "Search {{testCount}} tests from {{count}} lab company. Sign up as a practitioner to see pricing.",
  browseSubtitle_plural:
    "Search {{testCount}} tests from {{count}} lab companies. Sign up as a practitioner to see pricing.",
  companiesTitle: "Lab companies",
  companiesSubtitle: "{{count}} lab company available.",
  companiesSubtitle_plural: "{{count}} lab companies available.",
  companyPageTitle: "{{name}} lab tests",
  companyPageDescription: "Browse {{name}} lab tests. Sign up as a practitioner to see pricing.",
  companyTestsCount: "{{count}} test",
  companyTestsCount_plural: "{{count}} tests",
  categoryTitle: "{{category}} lab tests",
  categoryDescription: "Browse lab tests in {{category}}.",
  logIn: "Sign in",
  signUp: "Create account",
  goToLabsCatalog: "Go to labs catalog",
  chooseAccount: "Choose account",
  viewInCatalog: "View in catalog",
  pricingInYourCatalog: "Pricing available in your catalog",
  homeAriaLabel: "Fullscript",
  mobileNavMenuAriaLabel: "Open navigation menu",
  searchLabel: "Search",
  searchPlaceholder: "Search",
  companyFilter: "Company",
  companyFilterAll: "All",
  healthCategoryFilter: "Health category",
  healthCategoryFilterAll: "All",
  sampleTypeFilter: "Sample type",
  sampleTypeFilterAll: "All",
  sortLabel: "Sort",
  sortPopularity: "Most popular",
  sortBestMatch: "Best match",
  sortAlphabeticalAsc: "Alphabetical (A - Z)",
  sortAlphabeticalDesc: "Alphabetical (Z - A)",
  tableHeaderLabTest: "Lab test",
  tableHeaderSampleType: "Sample type",
  tableHeaderPrice: "Price",
  blurredPricePlaceholder: "$00.00",
  signUpToSeePrice: "Sign up to see price",
  emptyTitle: "No lab tests found",
  emptyDescription: "Try a different search or clear the filters.",
  emptyClearFilters: "Clear all filters",
  paginationPrevious: "Previous",
  paginationNext: "Next",
  paginationPage: "Page {{page}}",
  breadcrumbAriaLabel: "Breadcrumb",
  breadcrumbCatalog: "Labs catalog",
  breadcrumbCompanies: "Lab companies",
  detailDescription: "{{name}} from {{companyName}}.",
  patientTerm: "Patient",
  addOnsAvailable: "Add-ons available",
  detailSidebar: {
    pricingBadge: "Provider pricing unlocks when you sign up",
    headline: "Go from test to plan, in one place",
    benefit1: "2,500+ blood labs & specialty tests from partners you trust, one login",
    benefit2: "Turn results into personalized plans with <bold>Fullscript Assist</bold>",
    benefit3: "Competitive cash-pay pricing and <bold>nationwide phlebotomy</bold>",
    createFreeAccount: "Create free account",
    seeInLabsCatalog: "See in labs catalog",
    bookDemo: "Book a demo",
    trustedBy: "Trusted by 50,000+ practitioners",
    diagnosticPartnersCount: "20+",
    diagnosticPartnersLabel: "lab companies",
    ehrIntegrationsCount: "40+",
    ehrIntegrationsLabel: "EHR integrations",
    testimonialQuote:
      "Having labs on Fullscript has been a real time saver for my practice. I love the convenience and ability to order affordable labs quickly for my patients. It will be a staple in my workflow going forward.",
    testimonialName: "Joseph Thomas, MD",
    testimonialSubtitle: "Verified Fullscript practitioner",
    testimonialAvatarAlt: "Joseph Thomas",
    partnerLogoAlts: {
      quest: "Quest Diagnostics",
      accessMedical: "Access Medical Labs",
      threeByFourGenetics: "3x4 Genetics",
      practiceBetter: "Practice Better",
      cerbo: "Cerbo",
      optimantra: "OptiMantra",
    },
  },
};
